import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import {
	Api,
	CampaignBrief,
	CampaignBriefConfirmOrderCompletionsRequest,
	CampaignBriefFormattingRequest,
	CampaignBriefPrintingRequest,
	CampaignBriefUploadFilesRequest,
} from '~/api';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedCampaignBriefs: {} as Dict<CampaignBrief>,
	})
	.withGetters({
		byId: state => (id: number): CampaignBrief | null => (
			state.storedCampaignBriefs[id] ?? null
		),
	})
	.withMutations({
		STORE_CAMPAIGN_BRIEF (state, brief: CampaignBrief) {
			state.storedCampaignBriefs = {
				...state.storedCampaignBriefs,
				[brief.id]: brief,
			};
		},
	})
	.withActions({
		async get ({ commit }, id: number) {
			const { data } = await api.get(`/campaign-brief/${ id }`);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
		},

		async createFormatting ({ commit }, payload: CampaignBriefFormattingRequest) {
			const { data } = await api.post('/campaign-brief/formatting', payload);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
			return data.payload;
		},

		async updateFormatting ({ commit }, { id, ...payload }: { id: number } & CampaignBriefFormattingRequest) {
			const { data } = await api.put(`/campaign-brief/formatting/${ id }`, payload);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
			return data.payload;
		},

		async createPrinting ({ commit }, payload: CampaignBriefPrintingRequest) {
			const { data } = await api.post('/campaign-brief/printing', payload);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
			return data.payload;
		},

		async updatePrinting ({ commit }, { id, ...payload }: { id: number } & CampaignBriefPrintingRequest) {
			const { data } = await api.put(`/campaign-brief/printing/${ id }`, payload);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
			return data.payload;
		},

		async send ({ commit }, id: number) {
			const { data } = await api.post(`/campaign-brief/send/${ id }`);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
			return data.payload;
		},

		async uploadFiles ({ commit }, { id, ...payload }: { id: number } & CampaignBriefUploadFilesRequest) {
			const { data } = await api.post(`/campaign-brief/upload-files/${ id }`, payload);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
			return data.payload;
		},

		async confirmOrderCompletion ({ commit }, { id, ...payload }: { id: number } & CampaignBriefConfirmOrderCompletionsRequest) {
			const { data } = await api.post(`/campaign-brief/confirm-order-completion/${ id }`, payload);
			commit('STORE_CAMPAIGN_BRIEF', data.payload);
			return data.payload;
		},
	});

